// A1 - Ünite 3: There is / There are
// Hedef: Var/yok yapıları, uçak özelliklerini anlatma

export const A1_UNIT_3 = {
  'A1-U3-L1': {
    id: 'A1-U3-L1',
    title: 'There is + tekil',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 There is (Var - Tekil)',
          explanation: '"There is" tekil isimlerle kullanılır ve "var" anlamına gelir. Kısaltılmış hali: There\'s',
          table: {
            headers: ['Yapı', 'Örnek', 'Türkçesi'],
            rows: [
              ['There is + tekil isim', 'There is a pilot.', 'Bir pilot var.'],
              ['There\'s + tekil isim', 'There\'s a problem.', 'Bir sorun var.'],
              ['There is + a/an', 'There is an exit.', 'Bir çıkış var.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Uçak İçi Örnekler',
          table: {
            headers: ['Cümle', 'Türkçesi'],
            rows: [
              ['There is a restroom at the back.', 'Arkada bir tuvalet var.'],
              ['There is an emergency exit here.', 'Burada bir acil çıkış var.'],
              ['There is a life vest under your seat.', 'Koltuğunuzun altında can yeleği var.'],
              ['There is a meal service on this flight.', 'Bu uçuşta yemek servisi var.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "There is" yapısı uçağı yolculara tanıtırken çok kullanışlıdır!'
        },
        {
          type: 'vocabulary',
          title: '✈️ Uçak Bölümleri',
          words: [
            { en: 'cockpit', tr: 'kokpit', pronunciation: '/ˈkɒkpɪt/' },
            { en: 'galley', tr: 'mutfak', pronunciation: '/ˈɡæli/' },
            { en: 'lavatory', tr: 'tuvalet', pronunciation: '/ˈlævətɔːri/' },
            { en: 'overhead bin', tr: 'üst dolap', pronunciation: '/ˈəʊvəhed bɪn/' },
            { en: 'aisle', tr: 'koridor', pronunciation: '/aɪl/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'There _____ a restroom at the back.',
          options: ['is', 'are', 'be', 'am'],
          correct: 'is',
          explanation: 'Restroom tekil, bu yüzden "is" kullanılır'
        },
        {
          type: 'fillInBlank',
          sentence: 'There _____ an emergency exit on each side.',
          answer: 'is',
          hint: 'An emergency exit (tekil)'
        },
        {
          type: 'matching',
          instruction: 'Cümleleri tamamlayın',
          pairs: [
            { left: 'There is a pilot', right: 'in the cockpit' },
            { left: 'There is a life vest', right: 'under your seat' },
            { left: 'There is a restroom', right: 'at the back' }
          ]
        }
      ]
    }
  },
  'A1-U3-L2': {
    id: 'A1-U3-L2',
    title: 'There are + çoğul',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 There are (Var - Çoğul)',
          explanation: '"There are" çoğul isimlerle kullanılır ve "var" anlamına gelir.',
          table: {
            headers: ['Yapı', 'Örnek', 'Türkçesi'],
            rows: [
              ['There are + çoğul isim', 'There are 4 exits.', '4 çıkış var.'],
              ['There are + sayı', 'There are 180 seats.', '180 koltuk var.'],
              ['There are + some/many', 'There are many passengers.', 'Çok yolcu var.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Uçak Tanıtımı',
          table: {
            headers: ['Cümle', 'Türkçesi'],
            rows: [
              ['There are 4 cabin crew members.', '4 kabin ekibi üyesi var.'],
              ['There are 2 pilots in the cockpit.', 'Kokpitte 2 pilot var.'],
              ['There are 6 emergency exits.', '6 acil çıkış var.'],
              ['There are life vests under all seats.', 'Tüm koltukların altında can yeleği var.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 There is = tekil (1 şey) | There are = çoğul (2+ şey)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'There _____ 6 emergency exits on this aircraft.',
          options: ['is', 'are', 'be', 'am'],
          correct: 'are',
          explanation: '6 exits (çoğul) için "are" kullanılır'
        },
        {
          type: 'fillInBlank',
          sentence: 'There _____ 180 passengers on board.',
          answer: 'are',
          hint: '180 passengers (çoğul)'
        },
        {
          type: 'multipleChoice',
          question: 'There _____ many people waiting.',
          options: ['is', 'are', 'am', 'be'],
          correct: 'are',
          explanation: 'Many people (çoğul) için "are"'
        }
      ]
    }
  },
  'A1-U3-L3': {
    id: 'A1-U3-L3',
    title: "There isn't / There aren't",
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Olumsuz Yapılar',
          explanation: 'Bir şeyin olmadığını belirtmek için "isn\'t" veya "aren\'t" kullanılır.',
          table: {
            headers: ['Yapı', 'Örnek', 'Türkçesi'],
            rows: [
              ['There isn\'t + tekil', 'There isn\'t a problem.', 'Sorun yok.'],
              ['There aren\'t + çoğul', 'There aren\'t any delays.', 'Hiç rötar yok.'],
              ['There\'s no + tekil', 'There\'s no meal service.', 'Yemek servisi yok.'],
              ['There are no + çoğul', 'There are no empty seats.', 'Boş koltuk yok.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Olumsuz', 'Türkçesi'],
            rows: [
              ['There isn\'t any turbulence expected.', 'Türbülans beklenmiyor.'],
              ['There aren\'t any available upgrades.', 'Müsait upgrade yok.'],
              ['There\'s no wifi on this flight.', 'Bu uçuşta wifi yok.'],
              ['There are no more blankets.', 'Battaniye kalmadı.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "any" olumsuz cümlelerde kullanılır: There isn\'t ANY problem.'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: "There _____ any seats available.",
          options: ["isn't", "aren't", "is no", "are"],
          correct: "aren't",
          explanation: "Seats (çoğul) için aren't"
        },
        {
          type: 'fillInBlank',
          sentence: "There _____ a direct flight to that city.",
          answer: "isn't",
          hint: "A direct flight (tekil)"
        },
        {
          type: 'matching',
          instruction: 'Olumlu ve olumsuz formları eşleştirin',
          pairs: [
            { left: 'There is a delay', right: "There isn't a delay" },
            { left: 'There are seats', right: "There aren't seats" }
          ]
        }
      ]
    }
  },
  'A1-U3-L4': {
    id: 'A1-U3-L4',
    title: 'Is there...? Are there...?',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Soru Yapısı',
          explanation: 'Bir şeyin olup olmadığını sormak için "Is there...?" veya "Are there...?" kullanılır.',
          table: {
            headers: ['Soru', 'Cevap (Evet)', 'Cevap (Hayır)'],
            rows: [
              ['Is there a restroom?', 'Yes, there is.', 'No, there isn\'t.'],
              ['Are there any exits?', 'Yes, there are.', 'No, there aren\'t.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Yolcu Soruları',
          table: {
            headers: ['Soru', 'Türkçesi'],
            rows: [
              ['Is there wifi on this flight?', 'Bu uçuşta wifi var mı?'],
              ['Is there a meal service?', 'Yemek servisi var mı?'],
              ['Are there any vegetarian options?', 'Vejeteryan seçenek var mı?'],
              ['Are there any empty seats?', 'Boş koltuk var mı?']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "any" soru cümlelerinde de kullanılır: Is there ANY problem?'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '_____ there a doctor on board?',
          options: ['Is', 'Are', 'Do', 'Does'],
          correct: 'Is',
          explanation: 'A doctor (tekil) için "Is there"'
        },
        {
          type: 'multipleChoice',
          question: '_____ there any blankets available?',
          options: ['Is', 'Are', 'Do', 'Does'],
          correct: 'Are',
          explanation: 'Blankets (çoğul) için "Are there"'
        },
        {
          type: 'fillInBlank',
          sentence: '_____ there wifi on this flight?',
          answer: 'Is',
          hint: 'Wifi (tekil)'
        },
        {
          type: 'matching',
          instruction: 'Soruları cevaplarla eşleştirin',
          pairs: [
            { left: 'Is there a meal?', right: 'Yes, there is.' },
            { left: 'Are there any delays?', right: 'No, there aren\'t.' }
          ]
        }
      ]
    }
  },
  'A1-U3-L5': {
    id: 'A1-U3-L5',
    title: 'Uygulama: Uçak Tanıtımı',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '✈️ Uçak Tanıtım Metni',
          explanation: 'Yolculara uçağı tanıtırken kullanılan yapılar:',
          table: {
            headers: ['Cümle', 'Açıklama'],
            rows: [
              ['There are 6 emergency exits on this aircraft.', 'Acil çıkışlar'],
              ['There is a life vest under your seat.', 'Can yeleği'],
              ['There are oxygen masks above your seat.', 'Oksijen maskeleri'],
              ['There is a restroom at the front and back.', 'Tuvaletler'],
              ['There are safety cards in your seat pocket.', 'Güvenlik kartları']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Güvenlik gösterimi sırasında bu cümleleri kullanacaksınız!'
        },
        {
          type: 'vocabulary',
          title: '✈️ Güvenlik Ekipmanları',
          words: [
            { en: 'life vest', tr: 'can yeleği', pronunciation: '/laɪf vest/' },
            { en: 'oxygen mask', tr: 'oksijen maskesi', pronunciation: '/ˈɒksɪdʒən mæsk/' },
            { en: 'seat belt', tr: 'emniyet kemeri', pronunciation: '/siːt belt/' },
            { en: 'emergency exit', tr: 'acil çıkış', pronunciation: '/ɪˈmɜːdʒənsi ˈeksɪt/' },
            { en: 'safety card', tr: 'güvenlik kartı', pronunciation: '/ˈseɪfti kɑːd/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'fillInBlank',
          sentence: 'There _____ a life vest under your seat.',
          answer: 'is',
          hint: 'A life vest (tekil)'
        },
        {
          type: 'fillInBlank',
          sentence: 'There _____ 6 emergency exits.',
          answer: 'are',
          hint: '6 exits (çoğul)'
        },
        {
          type: 'multipleChoice',
          question: '_____ there any safety cards?',
          options: ['Is', 'Are', 'Do', 'Does'],
          correct: 'Are',
          explanation: 'Safety cards (çoğul)'
        },
        {
          type: 'speaking',
          instruction: 'Uçağı tanıtın:',
          phrases: [
            'There is/are... emergency exits',
            'There is a life vest...',
            'There are oxygen masks...',
            'There is a restroom...'
          ]
        }
      ]
    }
  },
  'A1-U3-EXAM': {
    id: 'A1-U3-EXAM',
    title: 'Ünite 3 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: 'There _____ a pilot in the cockpit.',
        options: ['is', 'are', 'am', 'be'],
        correct: 'is',
        explanation: 'A pilot (tekil)'
      },
      {
        type: 'multipleChoice',
        question: 'There _____ 4 cabin crew members.',
        options: ['is', 'are', 'am', 'be'],
        correct: 'are',
        explanation: '4 members (çoğul)'
      },
      {
        type: 'multipleChoice',
        question: "There _____ any delays today.",
        options: ["isn't", "aren't", "is", "are"],
        correct: "aren't",
        explanation: 'Delays (çoğul) + olumsuz'
      },
      {
        type: 'multipleChoice',
        question: '_____ there wifi on this flight?',
        options: ['Is', 'Are', 'Do', 'Does'],
        correct: 'Is',
        explanation: 'Wifi (tekil)'
      },
      {
        type: 'fillInBlank',
        sentence: 'There _____ life vests under all seats.',
        answer: 'are',
        hint: 'Life vests (çoğul)'
      },
      {
        type: 'matchPairs',
        instruction: 'Yapıları eşleştirin',
        pairs: [
          { left: 'There is', right: 'tekil isimlerle' },
          { left: 'There are', right: 'çoğul isimlerle' },
          { left: 'Is there...?', right: 'tekil soru' },
          { left: 'Are there...?', right: 'çoğul soru' }
        ]
      }
    ]
  }
};

export default A1_UNIT_3;
